import { Trash2 } from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react";

import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import CommonMaterialReactTable from "../../MaterialReactTable/CommonMaterialReactTable";
import apiHandler from "../../common/api";
import { Box } from "@mui/material";
import "sweetalert2/dist/sweetalert2.min.css";
import HeaderModule from "../../components/Header/HeaderModule";
import { useCheckUserPermission } from "../../common/userPermission";
import { dateFormat } from "../../common/common";

const notificationDelete = "notificationDelete";

const CustomerSupport = () => {
  const [productlist, setProductlist] = useState([]);
  const [deletes, setdelete] = useState(false);
  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = (id) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        showLoadingAlert(); // Show loader while deleting
        handleDelete(id);
      }
    });
  };

  const showLoadingAlert = () => {
    MySwal.fire({
      title: "Deleting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        MySwal.showLoading(); // Show loading spinner
      },
    });
  };

  const handleDelete = async (id) => {
    let reqobj = {
      ID: id,
      Module: "customerSupport",
    };

    try {
      const response = await apiHandler({
        method: "POST",
        route: "Superadmin/deletebymoduleid",
        payload: reqobj,
      });

      if (response.ResponseCode === "SUCCESS") {
        MySwal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          icon: "success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
        setdelete(!deletes);
      } else {
        MySwal.fire({
          title: "Error!",
          text: "Something went wrong. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      MySwal.fire({
        title: "Error!",
        text: "An error occurred. Please try again later.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const columns = [
    {
      header: "ID",
      accessorKey: "id",
      enableSorting: true,
      sortingFn: "numeric",
      size: 100,
    },
    {
      header: "Full Name",
      accessorKey: "name",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Email",
      accessorKey: "email",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Contact",
      accessorKey: "contact",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Reason",
      accessorKey: "reason",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Details",
      accessorKey: "extra",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Created On",
      accessorKey: "createdAt",
      enableSorting: true,
      sortingFn: "alphanumeric",
      Cell: ({ row }) => dateFormat(row.original.createdAt),
    },
    {
      accessorKey: "actions",
      header: "Actions",
      enableSorting: false,
      enableColumnFilter: false,
      size: 120,
      Cell: ({ row }) => (
        <Box sx={{ display: "flex", gap: "0.5rem" }}>
          {useCheckUserPermission(notificationDelete) && (
            <button
              className="btn btn-outline-primary btn-sm me-2"
              onClick={() => {
                showConfirmationAlert(row.original.id);
              }}
            >
              <Trash2 className="custome-icon-size" />
            </button>
          )}
        </Box>
      ),
    },
  ];

  const prodcutDataListApi = async () => {
    const response = await apiHandler({
      method: "GET",
      route: `Superadmin/customersupportlist`,
    });
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      setProductlist(response.ResponseData);
    } else {
      console.log(response, "data");
    }
  };

  useEffect(() => {
    prodcutDataListApi();
  }, [deletes]);

  const exportData = productlist.map((item) => ({
    ID: item?.id,
    Name: item?.name,
    Email: item?.email,
    Contact: item?.contact,
    Details: item?.extra,
    ["Created On"]: dateFormat(item?.createdAt),
  }));

  return (
    <div className="page-wrapper">
      <div className="content">
        <HeaderModule
          refreshData={prodcutDataListApi}
          exportData={exportData}
        />
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-responsive">
              <CommonMaterialReactTable
                columns={columns}
                data={productlist}
                columnRightPin={["actions"]}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerSupport;
